import React from 'react';
import { IconPropsType } from '../../misc/types';

const AddSquare = (props: IconPropsType) => {
  return (
    <svg
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-5 h-5 ` + props.additionalStyle}
    >
      <path
        d="M24.7883 4.03784H7.05676C5.65778 4.03784 4.52368 5.17194 4.52368 6.57092V24.3025C4.52368 25.7015 5.65778 26.8356 7.05676 26.8356H24.7883C26.1873 26.8356 27.3214 25.7015 27.3214 24.3025V6.57092C27.3214 5.17194 26.1873 4.03784 24.7883 4.03784Z"
        stroke="#353247"
        stroke-width="2.53308"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8563 15.4368H20.9886"
        stroke="#353247"
        stroke-width="2.53308"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9225 10.3706V20.5029"
        stroke="#353247"
        stroke-width="2.53308"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AddSquare;
